import fbIcon from '../../assets/icons/footerfb.svg';
import InstaIcon from '../../assets/icons/footerInsta.svg';
import LinkIcon from '../../assets/icons/footerlinkedIn.svg';
import Tweeticon from '../../assets/icons/footerTwitter.svg';
import LogoPrimaryWhite from '../../assets/images/Futurx_FooterLogoWebp.webp';
import './NewAppFooter.css';
import talkIcon from '../../assets/icons/talkIconBlack.svg';
import { Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useTypedSelector';
import ToastMsg from '../common/ToastMsg';
import openIcon from '../../assets/icons/openIcon.svg'
const NewAppFooter: React.FC = () => {



  const navigate = useNavigate();
  const isFreeUser = useAppSelector((state: any) => state.userData.freeUser);

  return (
    <div className="footer">
      <div className="footer-content">

        {/* Left Logo & Button */}
        <div className="footer-section" style={{ display: 'flex', flexDirection: 'column', gap: '1vw' }}>
          <img src={LogoPrimaryWhite} alt="FuturX Logo" className="footer-logo" height={'58px'} width={'240px'} loading='lazy' />
          <Button onClick={() => {
            if (isFreeUser) {
              navigate("/upgrade");
              ToastMsg('warning', 'Please upgrade to access this feature.');
            } else {
              navigate("/talk-to-expert");
            }
          }} icon={<img src={talkIcon} alt='talk icon' style={{ marginTop: "4px" }} />} className='outlinedBtn' style={{ borderRadius: '24px', width: '200px', height: "40px", marginLeft: "27px" }}>{"Talk to Expert"}</Button>
          <div className="footer-icons">
            <a href=" https://www.facebook.com/futurxofficial" target='_blank' rel="noreferrer" style={{ textDecoration: "none" }} ><img src={fbIcon} alt="facbook icon" style={{ width: "28px", height: "28px" }} /></a>
            <a href="https://www.instagram.com/futurxofficial" target='_blank' rel="noreferrer" style={{ textDecoration: "none" }}><img src={InstaIcon} alt="Instagram Icon" style={{ width: "28px", height: "28px" }} /></a>
            <a href="https://www.linkedin.com/company/futurxapp" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}><img src={LinkIcon} alt="LinkedIn Icon" style={{ width: "28px", height: "28px" }} /></a>
            <a href="https://x.com/FuturXApp" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}><img src={Tweeticon} alt="Twitter icon" style={{ width: "28px", height: "28px" }} /></a>
          </div>
        </div>

        {/* Popular Courses */}
        <div className="footer-section">
          <h4>Popular Majors</h4>
          <ul>
            <li><a href="/college/us-massachusetts-institute-of-technology/course/bachelor-computer-science" style={{ textDecoration: "none", color: "#e5e7eb" }}>Massachusetts Institute of Technology - Computer Science</a></li>
            <li><a href="/college/us-stanford-university/course/bachelor-economics" style={{ textDecoration: "none", color: "#e5e7eb" }}>Stanford University - Economics</a></li>
            <li><a href="/college/us-harvard-university/course/bachelor-biology-general" style={{ textDecoration: "none", color: "#e5e7eb" }}>Harvard University - Biology General</a></li>
            <li><a href="/college/us-california-institute-of-technology/course/bachelor-computer-science" style={{ textDecoration: "none", color: "#e5e7eb" }}>California Institute of Technology - Computer Science</a></li>
            <li><a href="/college/us-princeton-university/course/bachelor-anthropology" style={{ textDecoration: "none", color: "#e5e7eb" }}>Princeton university - Anthropology</a></li>
            <li><a href="/college/us-yale-university/course/bachelor-economics" style={{ textDecoration: "none", color: "#e5e7eb" }}>Yale University - Economics</a></li>
            <li><a href="/college/us-duke-university/course/doctorate-medicine" style={{ textDecoration: "none", color: "#e5e7eb" }}>Duke University - Medicine</a></li>
            <li><a href="/college/us-johns-hopkins-university/course/bachelor-biomedicalmedical-engineering" style={{ textDecoration: "none", color: "#e5e7eb" }}>Johns Hopkins University - Biomedical Engineering</a></li>
          </ul>
        </div>

        {/* Top Universities */}
        <div className="footer-section">
          <h4>Top Universities</h4>
          <ul>
            <li><a href="/college/us-princeton-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Princeton University</a></li>
            <li><a href="/college/us-massachusetts-institute-of-technology" style={{ textDecoration: "none", color: "#e5e7eb" }}>Massachusetts Institute of Technology</a></li>
            <li><a href="/college/us-harvard-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Harvard University</a></li>
            <li><a href="/college/us-stanford-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Stanford University</a></li>
            <li><a href="/college/us-yale-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Yale University</a></li>
            <li><a href="/college/us-duke-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Duke University</a></li>
            <li><a href="/college/us-johns-hopkins-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>John Hopkins University</a></li>
            <li><a href="/college/us-northwest-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Northwest University</a></li>
            <li><a href="/college/us-university-of-pennsylvania" style={{ textDecoration: "none", color: "#e5e7eb" }}>University of Pennsylvania</a></li>
            <li><a href="/college/us-cornell-university" style={{ textDecoration: "none", color: "#e5e7eb" }}>Cornell University</a></li>
            <li className="footer-link-green" style={{ listStyle: 'none' }}>
              <Link to="/search" className="footer-link-green" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                See all universities
              </Link>
            </li>
          </ul>
        </div>

        {/* Other Links */}
        <div className="footer-section">
          <h4>Other Links</h4>
          <ul>
            <li><a href="https://futurx.app/privacy-policy" target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#e5e7eb" }}>Privacy Policy</a><img src={openIcon} style={{ width: "14px", height: "14px", marginLeft: "10px" }} alt="open icon" /></li>
            <li><a href="https://futurx.app/terms-and-conditions" target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#e5e7eb" }} >Terms & Conditions</a><img src={openIcon} style={{ width: "14px", height: "14px", marginLeft: "10px" }} alt="open icon" /></li>
            <li><a href="/cookie-policy" target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#e5e7eb" }} >Cookie Policy</a><img src={openIcon} style={{ width: "14px", height: "14px", marginLeft: "10px" }} alt="open icon" /></li>

          </ul>
          <h4 style={{ marginTop: "20px" }}>Useful Tools</h4>
          <ul>
            <li><a href="https://futurx.app/emiCalculator" target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "#e5e7eb" }}>EMI Calculator</a><img src={openIcon} style={{ width: "14px", height: "14px", marginLeft: "10px" }} alt="open icon" /></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        © Copyright {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default NewAppFooter;
